import { render, staticRenderFns } from "./examInfo.vue?vue&type=template&id=88cc9c52&scoped=true&"
import script from "./examInfo.vue?vue&type=script&lang=js&"
export * from "./examInfo.vue?vue&type=script&lang=js&"
import style0 from "./examInfo.vue?vue&type=style&index=0&id=88cc9c52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cc9c52",
  null
  
)

export default component.exports